import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { brandSearchViewAllRequest } from "../../../redux/brands/BrandAction";
import { productQuantitySearchViewAllRequest } from "../../../redux/productQuantity/ProductQuantityAction";
import { productSearchViewAllRequest } from "../../../redux/products/ProductAction";
import { alcoholSearchViewAllRequest } from "../../../redux/typeOfAlcohol/TypeOfAlcoholAction";
import { wholesalerProductViewRequest } from "../../../redux/wholesalerProduct/WholesalerProductAction";
import "../../../style/style.css";
import { styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";

const ViewProduct = () => {
  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const wholesalerProductState = useSelector(
    (state) => state?.wholesalerProduct?.viewWholesalerProduct?.data || {}
  );
  const wholesalerProductList = wholesalerProductState || [];

  const productViewAllState = useSelector(
    (state) => state?.product?.viewAllSearchProducts || {}
  );
  const productList = productViewAllState?.data?.data || [];

  useEffect(() => {
    dispatch(productSearchViewAllRequest());
  }, [dispatch]);

  const brandViewAllState = useSelector(
    (state) => state?.brand?.viewAllSearchBrands || {}
  );
  const brandList = brandViewAllState?.data?.data || [];

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(brandSearchViewAllRequest());
    };
    fetchData();
  }, [dispatch]);

  const typeOfAlcoholState = useSelector(
    (state) => state?.TypeAlcohol?.viewAllSearchAlcohols || {}
  );
  const AlcoholList = typeOfAlcoholState?.data?.data || [];

  useEffect(() => {
    dispatch(alcoholSearchViewAllRequest());
  }, [dispatch]);

  const viewAllProductQuantitiesState = useSelector(
    (state) => state?.productQuantity?.viewAllSearchProductQuantities || {}
  );
  const productQuantityList = viewAllProductQuantitiesState?.data?.data || [];

  useEffect(() => {
    dispatch(productQuantitySearchViewAllRequest());
  }, [dispatch]);

  const inputFields = [
    {
      name: "type_of_alcohol_id",
      label: "Type Of Alochol",
      size: "medium",
      readOnly: true,
    },
    {
      name: "brand_id",
      label: "Brand Name",
      size: "semiMedium",
      readOnly: true,
    },
    {
      name: "product_id",
      label: "Sub Brand Name",
      size: "semiMedium",
      readOnly: true,
    },
    {
      name: "ProductQuantity",
      label: "Quantity",
      readOnly: true,
    },
    {
      name: "alcohol_percentage",
      label: "Alochol Percentage",
      readOnly: true,
    },
    { name: "price", label: "Price", readOnly: true },
    {
      name: "quantity",
      label: "Stock",
      readOnly: true,
    },
    {
      name: "status",
      label: "Status",
      readOnly: true,
    },
  ];

  const handleCancel = () => {
    navigate(APP_LINKS.PRODUCTLIST);
  };

  useEffect(() => {
    if (id) {
      dispatch(wholesalerProductViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (wholesalerProductList) {
      const brandName =
        brandList?.find((b) => b?.id === wholesalerProductList?.brand_id)
          ?.brand_name || "";
      const productName =
        productList?.find((p) => p?.id === wholesalerProductList?.product_id)
          ?.product_name || "";
      const alcoholType =
        AlcoholList?.find(
          (a) => a?.id === wholesalerProductList?.type_of_alcohol_id
        )?.alcohol_type || "";
      const quantityType = wholesalerProductList?.ProductQuantity
        ? `${wholesalerProductList.ProductQuantity.type_of_quantity} ${wholesalerProductList.ProductQuantity.measurements}`
        : "Quantity not available";
        
      setValue("brand_id", brandName);
      setValue("product_id", productName);
      setValue("type_of_alcohol_id", alcoholType);
      setValue("ProductQuantity", quantityType);
      setValue("alcohol_percentage", wholesalerProductList?.alcohol_percentage);
      setValue("price", wholesalerProductList?.price);
      setValue("quantity", wholesalerProductList?.quantity);
      const statusLabel =
        wholesalerProductList?.status === 1 ? "Active" : "Inactive";
      setValue("status", statusLabel);
    }
  }, [
    wholesalerProductList,
    brandList,
    productList,
    AlcoholList,
    productQuantityList,
    setValue,
  ]);

  return (
    <Container>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Product Overview </h1>
              </Typography>
            </Box>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
            />
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Back"
                    size="medium"
                    buttonStyle="StyledButton"
                    onClick={handleCancel}
                    disabled={wholesalerProductState?.inProgress}
                    loading={wholesalerProductState?.inProgress}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default ViewProduct;
